import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge must know our custom theme names, otherwise it mistakes
 * `text-cap` (a font size) for a colour and drops it next to `text-steel`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['2xs', 'cap', 'meta', 'note', 'ui', 'nav', 'title', 'kpi', 'figure'],
      color: [
        'navy',
        'navy-deep',
        'night',
        'paper',
        'ink',
        'ink-muted',
        'ink-faint',
        'steel',
        'steel-soft',
        'on-navy',
        'bar',
        'line',
        'field',
        'field-line',
        'row',
        'hot',
        'chip-line',
        'ok',
        'wait',
        'flag',
        'flag-ink',
        'flag-bg',
        'flag-line',
        'idle',
        'info',
        'hover-row',
        'flag-row',
        'ghost-hover',
        'check-line',
        'ink-disabled',
        'flag-field',
        'miss-line',
        'miss-bg',
        'wait-bg',
        'wait-ink',
        'ok-bg',
        'ok-line',
        'ok-ink',
      ],
      shadow: ['drawer', 'menu', 'dialog', 'ring'],
      animate: ['progress'],
    },
  },
})

/** Merge class names; later Tailwind utilities win over earlier ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
